import Api from '@/utils/axios/Api';
import user from "@/models/user"
const Http = Api.getInstance();




export const Delete = (type : string , id : number) => {
    return new Promise((resolve, reject) => {
        Http.delete(`${type}/${id}`)
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}

export const CityListAll = () => {
    return new Promise((resolve, reject) => {
        Http.get('city')
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}

export const BrandsListAll = () => {
    return new Promise((resolve, reject) => {
        Http.get('brands')
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}
export const Upload = (payload:Object) => {
    return new Promise((resolve, reject) => {
        Http.post('upload' , payload , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          })
        .then((d) => {
            resolve(d)
        }).catch(e => {
            reject(e)
        })
    })
}